import { createSlice } from "@reduxjs/toolkit";

const initialStoreItemApprovalState = {
  listLoading: false,
  actionsLoading: false,
  resolveLoading: false,
  totalCount: 0,
  entities: [],
  currentTab: "overview",
  storeItemApprovalForEdit: undefined,
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
  resolve: "resolve",
};

export const storeItemApprovalSlice = createSlice({
  name: "storeItemApprovals",
  initialState: initialStoreItemApprovalState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.resolve) {
        state.resolveLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.resolve) {
        state.resolveLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.resolve) {
        state.resolveLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getStoreItemApprovalById
    storeItemApprovalFetched: (state, action) => {
      state.actionsLoading = false;
      state.storeItemApprovalForEdit = action.payload.storeItemApprovalForEdit;
      state.floorPlans = action.payload.storeItemApprovalForEdit.floorPlans;
      state.error = null;
    },
    // getStoreItemApprovalChart
    storeItemApprovalChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.storeItemApprovalChart = action.payload.storeItemApprovalChart;
      state.error = null;
    },
    // getStoreItemApprovalChart
    storeItemApprovalHourlyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.storeItemApprovalChartHour =
        action.payload.storeItemApprovalChartHour;
      state.error = null;
    },
    // getStoreItemApprovalChart
    storeItemApprovalHourlyZoneChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.storeItemApprovalChartHourZone =
        action.payload.storeItemApprovalChartHourZone;
      state.error = null;
    },
    // get list data
    storeItemApprovalsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.storeItemApprovalForEdit = undefined;
      state.floorPlans = undefined;
      state.storeItemApprovalChart = undefined;
      state.storeItemApprovalChartHour = undefined;
      state.storeItemApprovalChartHourZone = undefined;
    },
    // createStoreItemApproval
    storeItemApprovalCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    // updateStoreItemApproval
    storeItemApprovalUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
    },
    // storeItemApprovalDeleted
    storeItemApprovalDeleted: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    storeItemResolveApproval: (state, action) => {
      state.error = null;
      state.resolveLoading = false;
      state.message = action.payload.msgResponse;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    setTab: (state, action) => {
      state.currentTab = action.payload.tab;
    },
  },
});
